var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"variant":"primary","dismissible":"","title":_vm.relatedUsername
      ? _vm.$t('related_guests_title')
      : _vm.$t('related_guests_title_multiple'),"icon":""},on:{"dismissed":_vm.onDismiss},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('CButton',{attrs:{"href":_vm.logoutUrl,"size":"xs","variant":"secondary"}},[_vm._v("\n      "+_vm._s(_vm.relatedUsername
          ? _vm.$t('related_guests_action_username', {
              username: _vm.relatedUsername
            })
          : _vm.$t('related_guests_action'))+"\n    ")])]},proxy:true}])},[_c('div',[_vm._v("\n    "+_vm._s(_vm.$t('related_guests_body'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }